import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { th, sortable } from '../styles.js';
import { IconSortable } from '../../icons/ui_control/IconSortable.web.js';
import { IconSortDesc } from '../../icons/ui_control/IconSortDesc.web.js';
import { IconSortAsc } from '../../icons/ui_control/IconSortAsc.web.js';
import { callOptional } from '../../utils/helpers/function.js';
import { useTheme } from '../../utils/theming/useTheme.js';

var _excluded = ["children", "size", "sortByThis", "sortable", "sortOrder", "columnKey", "onSort", "color", "stickyHeader"];
var Th = function Th(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 'medium' : _ref$size,
    sortByThis = _ref.sortByThis,
    sortable$1 = _ref.sortable,
    sortOrder = _ref.sortOrder,
    columnKey = _ref.columnKey,
    onSort = _ref.onSort,
    color = _ref.color,
    stickyHeader = _ref.stickyHeader,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleSort = React.useCallback(function (e) {
    callOptional(onSort)(e, columnKey);
  }, [onSort, columnKey]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(th, _extends({
    "data-testid": "elemental-TableHead-".concat(columnKey),
    $size: size,
    $color: color || theme.table.web.color,
    $stickyHeader: stickyHeader,
    scope: "col"
  }, props), sortable$1 ? /*#__PURE__*/React.createElement(sortable, {
    onClick: handleSort,
    type: "button",
    "data-testid": "elemental-TableHead-".concat(columnKey, "-sort")
  }, children, !sortByThis && /*#__PURE__*/React.createElement(IconSortable, {
    color: theme.tokens.border.inactive,
    size: 24
  }), sortByThis && sortOrder === 'desc' && /*#__PURE__*/React.createElement(IconSortDesc, {
    color: color,
    size: 24
  }), sortByThis && sortOrder === 'asc' && /*#__PURE__*/React.createElement(IconSortAsc, {
    color: color,
    size: 24
  })) : children);
};

export { Th };
